import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import _, { toNumber } from 'lodash';
import { esgSectionDetails, iconMapping } from '~/functions/helpers';
import { renderTrustedMarkdown } from '~/functions/markdown';
import { resolveRequireImpactSubmission } from '~/functions/accounts';
import { useGetAccountQuery, useGetQuestionnaireQuery, useGetQuestionnairesForVenturesAndLabelQuery, useUpdateQuestionnaireNavigationMutation } from '~/types/types';
import { esgModuleInfoForVenture } from '~/assets/esg';

// Access local translations

export default /*#__PURE__*/_defineComponent({
  __name: '_questionnaire',
  setup: function setup(__props) {
    var _route$query, _route$query2, _route$query3, _route$query4;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;

    // Route and params
    var route = useRoute();
    var router = useRouter();
    var ventureId = computed(function () {
      return route.params.venture;
    });
    var questionnaireId = computed(function () {
      return toNumber(route.params.questionnaire);
    });

    // Data properties
    var esgModuleInfo = esgModuleInfoForVenture;

    // Apollo queries
    var _useGetQuestionnaires = useGetQuestionnairesForVenturesAndLabelQuery({
        ventureIds: [ventureId.value],
        label: 'ESG'
      }),
      allQuestionnairesResult = _useGetQuestionnaires.result;
    var isFirstAssessment = computed(function () {
      var _allQuestionnairesRes;
      var all = (_allQuestionnairesRes = allQuestionnairesResult.value) === null || _allQuestionnairesRes === void 0 ? void 0 : _allQuestionnairesRes.getQuestionnairesForVenturesAndLabel;
      if (all && all.length === 1) return true;
      return false;
    });
    var _useGetQuestionnaireQ = useGetQuestionnaireQuery({
        id: questionnaireId.value
      }),
      result = _useGetQuestionnaireQ.result,
      loading = _useGetQuestionnaireQ.loading;
    var questionnaire = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getQuestionnaire;
    });
    var _useUpdateQuestionnai = useUpdateQuestionnaireNavigationMutation(),
      mutateQuestionnaireNavigation = _useUpdateQuestionnai.mutate;
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureId
      }),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value;
      return (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount;
    });
    var _useGetAccountQuery2 = useGetAccountQuery(),
      sessionAccountResult = _useGetAccountQuery2.result;
    var sessionAccount = computed(function () {
      var _sessionAccountResult;
      return (_sessionAccountResult = sessionAccountResult.value) === null || _sessionAccountResult === void 0 ? void 0 : _sessionAccountResult.getAccount;
    });
    var esgActionsActive = computed(function () {
      return account.value.esgActionsActive === true;
    });
    var requireReportSubmission = computed(function () {
      return resolveRequireImpactSubmission(sessionAccount.value, account.value);
    });

    // Reactive state
    var open = ref((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.currentSection ? [(_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.currentSection] : []);
    var active = ref((_route$query3 = route.query) !== null && _route$query3 !== void 0 && _route$query3.currentSubsection ? [(_route$query4 = route.query) === null || _route$query4 === void 0 ? void 0 : _route$query4.currentSubsection] : ['intro']);

    // Computed properties
    var selectedId = computed(function () {
      return active.value[0];
    });
    var subsection = computed(function () {
      var _sectionMapping$value;
      return (_sectionMapping$value = sectionMapping.value[selectedId.value]) === null || _sectionMapping$value === void 0 ? void 0 : _sectionMapping$value.subsection;
    });
    var navigation = computed(function () {
      var _questionnaire$value;
      return ((_questionnaire$value = questionnaire.value) === null || _questionnaire$value === void 0 ? void 0 : _questionnaire$value.questionnaireNavigation) || {
        currentSection: null,
        currentSubsection: null
      };
    });
    var questionnaireAssignment = computed(function () {
      var _questionnaire$value2;
      return ((_questionnaire$value2 = questionnaire.value) === null || _questionnaire$value2 === void 0 ? void 0 : _questionnaire$value2.questionnaireAssignment) || {
        userInputs: [],
        sectionCompletion: [],
        isEditable: false
      };
    });
    var questionnaireTemplate = computed(function () {
      var _questionnaire$value3;
      return (_questionnaire$value3 = questionnaire.value) === null || _questionnaire$value3 === void 0 ? void 0 : _questionnaire$value3.questionnaireTemplate;
    });
    var sections = computed(function () {
      var _questionnaireTemplat;
      if (!questionnaireTemplate.value) return [];
      return [{
        label: proxy.$t('introduction'),
        id: 'intro'
      }].concat(_toConsumableArray(((_questionnaireTemplat = questionnaireTemplate.value) === null || _questionnaireTemplat === void 0 ? void 0 : _questionnaireTemplat.sections) || []), [{
        label: requireReportSubmission.value ? proxy.$t('nextSteps') : proxy.$t('done'),
        id: 'outro'
      }]);
    });
    var userInputMapping = computed(function () {
      if (!questionnaireAssignment.value) return {};
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray(questionnaireAssignment.value.userInputs.map(function (x) {
        return _defineProperty({}, x.question.id, x);
      }))));
    });
    var sectionCompletionMapping = computed(function () {
      if (!questionnaireAssignment.value) return {};
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray(questionnaireAssignment.value.sectionCompletion.map(function (item) {
        return _defineProperty({}, item.sectionId, item);
      }))));
    });
    var sectionMapping = computed(function () {
      var _questionnaireTemplat2, _questionnaireTemplat3;
      if (!questionnaireTemplate.value) return {};
      var result = {};
      (_questionnaireTemplat2 = questionnaireTemplate.value) === null || _questionnaireTemplat2 === void 0 ? void 0 : (_questionnaireTemplat3 = _questionnaireTemplat2.sections) === null || _questionnaireTemplat3 === void 0 ? void 0 : _questionnaireTemplat3.forEach(function (section) {
        return section.sections.forEach(function (subsection) {
          result[subsection.id] = {
            subsection: subsection,
            parent_id: section.id
          };
        });
      });
      return result;
    });
    var orderedNavigation = computed(function () {
      var _questionnaireTemplat4, _questionnaireTemplat5;
      if (!questionnaireTemplate.value) return [];
      var result = [];
      (_questionnaireTemplat4 = questionnaireTemplate.value) === null || _questionnaireTemplat4 === void 0 ? void 0 : (_questionnaireTemplat5 = _questionnaireTemplat4.sections) === null || _questionnaireTemplat5 === void 0 ? void 0 : _questionnaireTemplat5.forEach(function (section) {
        return section.sections.forEach(function (subsection) {
          result.push({
            section: section.id,
            subsection: subsection.id
          });
        });
      });
      return result;
    });
    var navigationSteps = computed(function () {
      if (!orderedNavigation.value) return {};
      var result = {};
      orderedNavigation.value.forEach(function (value, index) {
        result[value.subsection] = {
          prev: orderedNavigation.value[index - 1] || {
            section: null,
            subsection: 'intro'
          },
          next: orderedNavigation.value[index + 1] || {
            section: null,
            subsection: 'outro'
          }
        };
      });
      return result;
    });
    var allQuestionsAnswered = computed(function () {
      if (!questionnaireAssignment.value) return false;
      return questionnaireAssignment.value.sectionCompletion.every(function (item) {
        return item.isCompleted;
      });
    });
    var isCompleteButNotSubmitted = computed(function () {
      return requireReportSubmission.value && allQuestionsAnswered.value && questionnaireAssignment.value.isEditable;
    });

    // Only prompt when the assessment is already complete on first open (e.g. filled
    // earlier without submitting, or answers copied from a previous assessment).
    // Do not prompt when the user finishes the last section during this session.
    var showSubmitPrompt = ref(false);
    var hasEvaluatedInitialSubmitPrompt = ref(false);
    watch([loading, questionnaire, isCompleteButNotSubmitted, isFirstAssessment], function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 4),
        isLoading = _ref5[0],
        q = _ref5[1],
        isComplete = _ref5[2],
        isFirst = _ref5[3];
      if (isLoading || !q || hasEvaluatedInitialSubmitPrompt.value) return;
      hasEvaluatedInitialSubmitPrompt.value = true;
      // Skip brand-new first assessments — prompt is for reopen / copied prior data.
      if (isComplete && !isFirst) {
        showSubmitPrompt.value = true;
      }
    }, {
      immediate: true
    });
    watch(requireReportSubmission, function (isRequired) {
      if (!isRequired) {
        showSubmitPrompt.value = false;
        if (selectedId.value === 'outro') {
          active.value = ['intro'];
        }
      }
    }, {
      immediate: true
    });
    var isOldEsg = computed(function () {
      var _questionnaireTemplat6, _questionnaireTemplat7, _questionnaireTemplat8;
      return [2, 3, 8, 19].includes((_questionnaireTemplat6 = questionnaireTemplate.value) === null || _questionnaireTemplat6 === void 0 ? void 0 : (_questionnaireTemplat7 = _questionnaireTemplat6.sections) === null || _questionnaireTemplat7 === void 0 ? void 0 : (_questionnaireTemplat8 = _questionnaireTemplat7[0]) === null || _questionnaireTemplat8 === void 0 ? void 0 : _questionnaireTemplat8.id);
    });

    // Methods
    var isEmpty = function isEmpty(item) {
      return _.isEmpty(item);
    };
    var updateNavigationViaSidebar = function updateNavigationViaSidebar(activeVal) {
      var _sectionMapping$value2, _sectionMapping$value3;
      if (isEmpty(activeVal)) return;
      active.value = activeVal;
      var subsectionId = activeVal[0];
      if (['intro', 'outro'].includes(subsectionId)) return;
      var sectionId = (_sectionMapping$value2 = sectionMapping.value) === null || _sectionMapping$value2 === void 0 ? void 0 : (_sectionMapping$value3 = _sectionMapping$value2[subsectionId]) === null || _sectionMapping$value3 === void 0 ? void 0 : _sectionMapping$value3.parent_id;
      if (questionnaireId.value) {
        mutateQuestionnaireNavigation({
          input: {
            id: questionnaireId.value,
            currentSection: sectionId,
            currentSubsection: subsectionId
          }
        }); // FIXME: I don't think this is necessary plus this wont' support multiple clients
        router.push({
          query: _objectSpread(_objectSpread({}, route.query), {}, {
            currentSection: sectionId,
            currentSubsection: subsectionId
          })
        });
      }
    };
    var updateNavigationViaButton = function updateNavigationViaButton(sectionId, subsectionId) {
      active.value = [subsectionId];
      open.value = [sectionId];
      if (['intro', 'outro'].includes(subsectionId)) return;
      if (questionnaireId.value) mutateQuestionnaireNavigation({
        input: {
          id: questionnaireId.value,
          currentSection: sectionId,
          currentSubsection: subsectionId
        }
      });
    };
    var updateOpen = function updateOpen(val) {
      if (val.length > 1) open.value = [val.pop()];
    };
    return {
      __sfc: true,
      proxy: proxy,
      route: route,
      router: router,
      ventureId: ventureId,
      questionnaireId: questionnaireId,
      esgModuleInfo: esgModuleInfo,
      allQuestionnairesResult: allQuestionnairesResult,
      isFirstAssessment: isFirstAssessment,
      result: result,
      loading: loading,
      questionnaire: questionnaire,
      mutateQuestionnaireNavigation: mutateQuestionnaireNavigation,
      accountResult: accountResult,
      account: account,
      sessionAccountResult: sessionAccountResult,
      sessionAccount: sessionAccount,
      esgActionsActive: esgActionsActive,
      requireReportSubmission: requireReportSubmission,
      open: open,
      active: active,
      selectedId: selectedId,
      subsection: subsection,
      navigation: navigation,
      questionnaireAssignment: questionnaireAssignment,
      questionnaireTemplate: questionnaireTemplate,
      sections: sections,
      userInputMapping: userInputMapping,
      sectionCompletionMapping: sectionCompletionMapping,
      sectionMapping: sectionMapping,
      orderedNavigation: orderedNavigation,
      navigationSteps: navigationSteps,
      allQuestionsAnswered: allQuestionsAnswered,
      isCompleteButNotSubmitted: isCompleteButNotSubmitted,
      showSubmitPrompt: showSubmitPrompt,
      hasEvaluatedInitialSubmitPrompt: hasEvaluatedInitialSubmitPrompt,
      isOldEsg: isOldEsg,
      isEmpty: isEmpty,
      updateNavigationViaSidebar: updateNavigationViaSidebar,
      updateNavigationViaButton: updateNavigationViaButton,
      updateOpen: updateOpen,
      esgSectionDetails: esgSectionDetails,
      iconMapping: iconMapping,
      renderTrustedMarkdown: renderTrustedMarkdown
    };
  }
});